function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const api = buildService('/elsters/{id}/partnership', {
  only: ['all', 'update']
});
const partnershipsService = {
  useFetchPartnership: function (elsterId, setLoading) {
    let fetchImmediately = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return serviceMethods.useFetch({
      callback: useCallback(async () => {
        return api.all(elsterId);
      }, [elsterId]),
      setLoading,
      fetchImmediately,
      initialStateValue: null
    });
  },
  useUpdatePartnership: (elsterId, setLoading, setPartnership) => {
    const updatePartnership = serviceMethods.useUpdate({
      callback: useCallback(async payload => {
        const response = await api.update(elsterId, '', payload);
        setPartnership(prev => _objectSpread(_objectSpread({}, prev), response));
        return response;
      }, [elsterId, setPartnership]),
      setLoading
    });
    return [updatePartnership];
  }
};
partnershipsService.useCrud = function (elsterId, setLoading) {
  let fetchImmediately = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const [partnership, setPartnership, fetchPartnership] = partnershipsService.useFetchPartnership(elsterId, setLoading, fetchImmediately);
  const [updatePartnership] = partnershipsService.useUpdatePartnership(elsterId, setLoading, setPartnership);
  return {
    partnership,
    setPartnership,
    fetchPartnership,
    updatePartnership
  };
};
export default partnershipsService;